<template>
    <div class="grid grid__col" ref="col"
        :style="columnStyles">
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                    <h6 class="text-uppercase text-left">Cols ({{ grids }})</h6>
                    <v-card ref="grid" tile flat v-on="on"
                        color="blue-grey lighten-3"
                        :dark="dark" class="grid" @click="dialog = true">
                        <v-card-text class="text-center">
                            <slot>{{ colFixedWidth }}px</slot>
                        </v-card-text>
                    </v-card>
            </template>
            <div class="py-3">
                <div>Grid Width (px): {{ gridFixedWidth }}</div>
                <div>Column Width (%): {{ gridSize.toFixed(3) }}</div>
                <div>Column Width (px): {{ colFixedWidth }}</div>
            </div>
        </v-tooltip>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'grid-column',
  props: {
    grids: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  data() {
    return {
      gridFixedWidth: 0,
      colFixedWidth: 0,
    };
  },
  computed: {
    ...mapGetters([
      'gridSize',
      'gutterUnitSpace',
    ]),
    columnStyles() {
      return {
        width: `${this.grids * this.gridSize}%`,
        paddingLeft: `${this.gutterUnitSpace}px`,
        paddingRight: `${this.gutterUnitSpace}px`,
      };
    },
    dark() {
      return false;
    },
  },
  methods: {
    updateGrid() {
      this.$nextTick(() => {
        if (this.$refs.grid) {
          this.gridFixedWidth = this.$refs.grid.$el.clientWidth;
        }
        if (this.$refs.col) {
          this.colFixedWidth = this.$refs.col.clientWidth;
        }
      });
    },
  },
  mounted() {
    this.updateGrid();
  },
  watch: {
    gridSize() {
      this.updateGrid();
    },
    gutterUnitSpace() {
      this.updateGrid();
    },
    grids() {
      this.updateGrid();
    },
  },
};
</script>
